import ClaimsService from "@/api/services/claims";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    quotationStatusClass: () => (status) => {
      switch (status) {
        case "approved":
          return "bg-green-200 text-green-800";
        case "to_be_approved":
          return "bg-yellow-200 text-yellow-800";
        case "refused":
          return "bg-red-200 text-red-800";
        default:
          return "bg-gray-200 text-gray-600";
      }
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.claimQuotations;
    },
  },
  actions: {
    async fetchIndex({ commit }, { claimId }) {
      const response = await ClaimsService.fetchClaimQuotations({ claimId });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
  },
};
